import request from '@/utils/request'

export function PerfectInformation(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/PerfectInformation',
        method: 'post',
        data
    })
}

export function GetEntityByID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Enterprises/GetEntityByID',
        method: 'post',
        params:data
    })
}

//操作日志
export function GetLogListPage(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetLogListPage',
        method: 'get',
        params:data
    })
}


export function GetUserinfo(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetUserinfo',
        method: 'post',
        params:data
    })
}

//个人账号注销
export function AccountLogout(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/AccountLogout',
        method: 'post',
        params:data
    })
}
//忘记密码
export function ChangePassword(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/ChangePassword',
        method: 'post',
        params:data
    })
}

//申请绑定企业
export function Applyforenterprisebinding(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/Applyforenterprisebinding',
        method: 'post',
        params:data
    })
}


//审核绑定企业
export function ReviewBindingEnterprise(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/ReviewBindingEnterpriseMethod',
        method: 'post',
        params:data
    })
}

//获取申请绑定企业列表
export function GetReviewBindingEnterpriseListPage(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetReviewBindingEnterpriseListPage',
        method: 'get',
        params:data
    })
}

//根据用户ID获取最新的申请审核记录
export function GetReviewBindingEnterpriseByUserID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetReviewBindingEnterpriseByUserID',
        method: 'post',
        params:data
    })
}


//上传图片
export function UploadQianming(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/UploadQianming',
        method: 'post',
        data,
        contentType:"multipart/form-data"
    })
}

//获取微信绑定状态
export function GetWechatBindStatus(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/userwechatauth/bindstatus',
        method: 'get',
        params: data
    })
}

//绑定微信
export function BindWechat(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/userwechatauth/bind',
        method: 'post',
        params: data
    })
}

//解绑微信
export function UnbindWechat(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/userwechatauth/unbind',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/areas/PersonalCenter/api/Center.js